import styles from './styles.module.scss';
import 'photoswipe/dist/photoswipe.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import React, {useEffect, useRef, useState} from "react";
import Step2 from "../Step2";
import Step3 from "../Step3";
import StepNav from "../StepNav";
import {useAppData} from "../../context/Contexts";
import StepNoCompatible from '../StepNoCompatible';


const MainStep: React.FC = (props) => {
    const {currentAppData, setCurrentAppData} = useAppData();
    const [incompatible, setIncompatible] = useState<boolean>(false);

    useEffect(() => {
        setIncompatible((typeof currentAppData?.check !== 'undefined'
            && currentAppData?.check?.compatibility === 'N'
            && currentAppData?.check?.compatibility_custom === 'N'
            && currentAppData?.step === 3));
    }, [currentAppData]);

    // console.log(
    //     'incompatible=',
    //     currentAppData?.check?.compatibility,
    //     (typeof currentAppData?.check !== 'undefined' && !!currentAppData?.check?.compatibility),
    //     incompatible
    // );

    return (<>
        {!incompatible ? (<><Step2/>
        <Step3/>
        <StepNav/></>): ''}
    </>);
};

export default MainStep;